import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './pages/app';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.querySelector('#root'),
);
